<template>
  <H5Layout title="用户管理" active="">
    <ZUser></ZUser>
  </H5Layout>
</template>

<script>
import H5Layout from "./H5Layout.vue";
import ZUser from "@/vue_views/ZUser.vue";

export default {
  name: "UserH5",
  components: {
    H5Layout,
    ZUser
  }
}
</script>

<style>
.h5-layout .el-table__body-wrapper {
  overflow-x: auto;
}
</style>
